const statsTypes = {
  RESET_DAILY_FB_CAMPAIGN_INSIGHT_STATE: 'RESET_DAILY_FB_CAMPAIGN_INSIGHT_STATE',
  DAILY_FB_CAMPAIGN_INSIGHTS: {
    REQUEST: 'DAILY_FB_CAMPAIGN_INSIGHTS.REQUEST',
    SUCCESS: 'DAILY_FB_CAMPAIGN_INSIGHTS.SUCCESS',
    FAILURE: 'DAILY_FB_CAMPAIGN_INSIGHTS.FAILURE',
  },
};

export default statsTypes;
